import { type Price } from 'types/isomorphic';

// The server marks the default size. Sizes without a flag (the preview sizes
// come from the host's asset) default to the last size.
export const defaultSizeIndex = (sizes: Pick<Price, 'isDefault'>[]): number => {
  const flagged = sizes.findIndex((size) => size.isDefault);
  return flagged >= 0 ? flagged : Math.max(0, sizes.length - 1);
};
